var React = require('react');

function Navigation (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.723 0.913958C4.87669 0.511815 5.43293 0.478977 5.63286 0.860245L10.3273 9.81231C10.5378 10.2136 10.1486 10.6655 9.72049 10.5169L5.6933 9.11851C5.55289 9.06976 5.39806 9.086 5.27083 9.16283L1.70486 11.3162C1.29763 11.5621 0.809517 11.154 0.979342 10.7097L4.723 0.913958Z","fill":"white"}));
}

Navigation.defaultProps = {"width":"11","height":"12","viewBox":"0 0 11 12","fill":"none"};

module.exports = Navigation;

Navigation.default = Navigation;
